import React from 'react';

const ResearchReductionForm = ({ isOpen, onClose, onSubmit, name, setName, score, setScore, categoryType, setCategoryType, isEditing, isReadOnly }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay" style={{ zIndex: 1050 }}>
            <div className="modal-box" style={{ width: '90%', maxWidth: '650px' }}>
                <div className="modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <h3 style={{ margin: 0, paddingRight: '20px', lineHeight: '1.4' }}>
                        {isReadOnly ? (
                            <><i className="fa-solid fa-eye" style={{ marginRight: '8px', color: '#6c757d' }}></i> Xem chi tiết Lịch sử</>
                        ) : (
                            <><i className={isEditing ? "fa-solid fa-pen-to-square" : "fa-solid fa-plus-circle"} style={{ marginRight: '8px' }}></i> {isEditing ? "Cập nhật Giảm trừ" : "Thêm mới Danh mục"}</>
                        )}
                    </h3>
                    <button className="close-btn" onClick={onClose} style={{ fontSize: '26px', lineHeight: '1', flexShrink: 0, marginTop: '-2px' }}>
                        &times;
                    </button>
                </div>

                <div className="modal-body" style={{ padding: '25px' }}>
                    <form id="researchReductionForm" onSubmit={onSubmit}>
                        {isReadOnly && (
                            <div style={{ marginBottom: '15px', padding: '10px', backgroundColor: '#fff3cd', color: '#856404', borderRadius: '4px', borderLeft: '4px solid #ffeeba', fontSize: '13px' }}>
                                <i className="fa-solid fa-circle-info" style={{ marginRight: '6px' }}></i>
                                Đây là danh mục lịch sử đã bị ẩn khỏi hệ thống. Bạn chỉ có thể xem, không thể chỉnh sửa.
                            </div>
                        )}
                        <div className="form-group" style={{ marginBottom: '20px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                                Nhóm phân loại để tính điểm {!isReadOnly && <span className="text-red">*</span>}
                            </label>
                            <select
                                className="form-input"
                                style={{ width: '100%', padding: '10px 12px', borderRadius: '6px', border: '1px solid #cbd5e1', backgroundColor: isReadOnly ? '#f1f5f9' : '#fff' }}
                                value={categoryType}
                                onChange={(e) => setCategoryType(Number(e.target.value))}
                                disabled={isReadOnly}
                            >
                                <option value={1}>Loại 1: Chức vụ / Công việc</option>
                                <option value={2}>Loại 2: Đi học / Bồi dưỡng</option>
                                <option value={3}>Loại 3: Thai sản / Nghỉ chế độ</option>
                            </select>
                        </div>
                        <div className="form-group" style={{ marginBottom: '20px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                                Nội dung chi tiết {!isReadOnly && <span className="text-red">*</span>}
                            </label>
                            <textarea
                                className="form-input"
                                rows="3"
                                style={{ resize: 'vertical', backgroundColor: isReadOnly ? '#f1f5f9' : '#fff' }}
                                placeholder="Nhập chức danh/nội dung giảm trừ"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                autoFocus={!isReadOnly}
                                disabled={isReadOnly}
                            />
                        </div>
                        <div className="form-group">
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                                Tỉ lệ giảm (%) {!isReadOnly && <span className="text-red">*</span>}
                            </label>
                            <input
                                type="number"
                                className="form-input"
                                placeholder="Nhập tỉ lệ"
                                value={score}
                                onChange={(e) => setScore(e.target.value)}
                                disabled={isReadOnly}
                                style={{ backgroundColor: isReadOnly ? '#f1f5f9' : '#fff' }}
                            />
                        </div>
                    </form>
                </div>

                <div className="modal-footer" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                    {isReadOnly ? (
                        <button type="button" className="btn-cancel" onClick={onClose}>
                            Đóng
                        </button>
                    ) : (
                        <>
                            <button type="button" className="btn-cancel" onClick={onClose}>
                                <i className="fa-solid fa-xmark" style={{ marginRight: '6px' }}></i> Hủy
                            </button>
                            <button type="submit" form="researchReductionForm" className="btn-submit">
                                <i className="fa-solid fa-check" style={{ marginRight: '6px' }}></i> Hoàn tất
                            </button>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ResearchReductionForm;